<app-not-found *ngIf="pageNotFound"></app-not-found>

<ng-container *ngIf="!pageNotFound && (page$ | async) as page">
  <ng-container *ngFor="let layout of sortedLayouts(page)">
    <app-layout [layout]="layout"></app-layout>
  </ng-container>
</ng-container>
